import React, { useMemo } from 'react';

import { LoadedEventView } from '@atlas/core';
import { Loader } from '@atlas/ui';

import DetailsEvent from './DetailsEvent';

/*
  Currently using in global scope
*/
const Details = ({ isIframe = false }) => {
  const loader = useMemo(
    () => (
      <div className="details-event-loader">
        <Loader className="absolute" />
      </div>
    ),
    [],
  );

  return (
    <LoadedEventView fallback={loader}>
      <DetailsEvent isIframe={isIframe} />
    </LoadedEventView>
  );
};

export default Details;
